<t4-header icon="glyphicon-stats">
  <button mat-button color="primary" matTooltip="{{ 'Turbo.OneWayAdmin.Service.cmdFind' | translate:'Find Request'}}" (click)="FindIssue()"><mat-icon>search</mat-icon></button>
</t4-header>
<h1>{{ 'Turbo.OneWayAdmin.Claims.Headline' | translate:'Claims'}}</h1>

<t4-container title=" ">
  <mat-form-field style="max-width:400px;">
    <mat-label>Owners</mat-label>
    <mat-select [formControl]="groupsControl" multiple (selectionChange)="applyFilter()">
      <mat-option [value]="r" *ngFor="let r of owners">{{r}}</mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field style="width: 100%;">
    <input matInput placeholder="{{ 'Turbo.OneWayAdmin.Service.lblFilter' | translate:'Find issues'}}" [(ngModel)]="filterText" (ngModelChange)="filter($event)">
  </mat-form-field>
</t4-container>

<t4-container title=" ">
  <mat-tab-group (selectedTabChange)="tabChange($event)">

    <mat-tab label="{{ 'Turbo.OneWayAdmin.Claims.headNew' | translate:'New'}} ({{ newClaims?.data?.filteredData?.length }})">

      <t4-data-table matSortActive="CreatedAt" #newClaims [rawData]="filteredNewClaims" headline="" [allowFilter]="false" matSort [filterFields]="['Country','ClaimId', 'RequestNo', 'RentalObject.Title', 'RentalObject.RentalLocation.Name', 'RentalObject.RentalLocation.City', 'Owner']" [autoGenerateColumns]="false">

        <!-- ID Column -->
        <ng-container matColumnDef="userId">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 50px;"></mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 50px;" (click)="showDetails(row.Id)"><div class="statusIcon" [ngClass]="{'status-red': (row.CreatedAt < threeDaysBack), 'status-yellow': (row.CreatedAt < yesterday && row.CreatedAt >= threeDaysBack) }"></div></mat-cell>
        </ng-container>
        <ng-container matColumnDef="Country">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblCountry' | translate:'Country'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.Country }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="ClaimId">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Claims.lblClaimId' | translate:'Claim Id'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.ClaimId }}</mat-cell>
        </ng-container>

        <!-- Progress Column -->
        <ng-container matColumnDef="CreatedAt">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblCreated' | translate:'Created at'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.CreatedAt | date : 'yyMMdd' }}</mat-cell>
        </ng-container>

        <!-- Color Column -->
        <ng-container matColumnDef="RentalObject.Title">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblTrailer' | translate:'Trailer'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;"><t4-object-link [objectId]="row.RentalObject.Id">{{row.RentalObject.Title}}</t4-object-link></mat-cell>
        </ng-container>
        <ng-container matColumnDef="RentalObject.RentalLocation.Name">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 200px;">{{ 'Turbo.OneWayAdmin.Service.lblTrailer' | translate:'Trailer'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 200px;"><t4-location-link [locationId]="row.RentalObject.RentalLocation.Id">{{ row.RentalObject.RentalLocation.Name }}</t4-location-link></mat-cell>
        </ng-container>
        <ng-container matColumnDef="Status">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 150px;">
            {{
 'Turbo.OneWayAdmin.Service.lblStatus' | translate:'Status'
            }}
          </mat-header-cell>
          <mat-cell *matCellDef="let row" (click)="showDetails(row.Id)" style="flex: 0 0 150px;">{{ 'Turbo.OneWayAdmin.Service.ServiceStatus.' + row.Status | translate }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="StatusDate">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Claims.lblStatusDate' | translate:'Status date'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.StatusDate | date : 'yyMMdd' }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Owner">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblOwner' | translate:'Owner'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.Owner }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Description">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Turbo.OneWayAdmin.Service.lblDescription' | translate:'Description'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" (click)="showDetails(row.Id)">{{ row.Description }}</mat-cell>
        </ng-container>

      </t4-data-table>
    </mat-tab>

    <mat-tab label="{{ 'Turbo.OneWayAdmin.Claims.headWaitingForDecision' | translate:'Waiting for decision'}} ({{ decisionClaims?.data?.filteredData?.length }})">

      <t4-data-table matSortActive="CreatedAt" #decisionClaims [rawData]="filteredWaitingForDecisionClaims" headline="" [allowFilter]="false" matSort [filterFields]="['Country','ClaimId', 'RequestNo', 'RentalObject.Title', 'RentalObject.RentalLocation.Name', 'RentalObject.RentalLocation.City', 'Owner']" [autoGenerateColumns]="false">

        <!-- ID Column -->
        <ng-container matColumnDef="userId">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 50px;"></mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 50px;" (click)="showDetails(row.Id)"><div class="statusIcon" [ngClass]="{'status-red': (row.CreatedAt < threeDaysBack), 'status-yellow': (row.CreatedAt < yesterday && row.CreatedAt >= threeDaysBack) }"></div></mat-cell>
        </ng-container>
        <ng-container matColumnDef="Country">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblCountry' | translate:'Country'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.Country }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="ClaimId">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Claims.lblClaimId' | translate:'Claim Id'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.ClaimId }}</mat-cell>
        </ng-container>

        <!-- Progress Column -->
        <ng-container matColumnDef="CreatedAt">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblCreated' | translate:'Created at'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.CreatedAt | date : 'yyMMdd' }}</mat-cell>
        </ng-container>

        <!-- Color Column -->
        <ng-container matColumnDef="RentalObject.Title">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblTrailer' | translate:'Trailer'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;"><t4-object-link [objectId]="row.RentalObject.Id">{{row.RentalObject.Title}}</t4-object-link></mat-cell>
        </ng-container>
        <ng-container matColumnDef="RentalObject.RentalLocation.Name">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 200px;">{{ 'Turbo.OneWayAdmin.Service.lblTrailer' | translate:'Trailer'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 200px;"><t4-location-link [locationId]="row.RentalObject.RentalLocation.Id">{{ row.RentalObject.RentalLocation.Name }}</t4-location-link></mat-cell>
        </ng-container>
        <ng-container matColumnDef="Status">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 150px;">
            {{
 'Turbo.OneWayAdmin.Service.lblStatus' | translate:'Status'
            }}
          </mat-header-cell>
          <mat-cell *matCellDef="let row" (click)="showDetails(row.Id)" style="flex: 0 0 150px;">{{ 'Turbo.OneWayAdmin.Service.ServiceStatus.' + row.Status | translate }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="StatusDate">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Claims.lblStatusDate' | translate:'Status date'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.StatusDate | date : 'yyMMdd' }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Owner">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblOwner' | translate:'Owner'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.Owner }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Description">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Turbo.OneWayAdmin.Service.lblDescription' | translate:'Description'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" (click)="showDetails(row.Id)">{{ row.Description }}</mat-cell>
        </ng-container>

      </t4-data-table>
    </mat-tab>

    <mat-tab label="{{ 'Turbo.OneWayAdmin.Claims.headWaitingForSpareParts' | translate:'Waiting for spare parts'}} ({{ sparePartsClaims?.data?.filteredData?.length }})">

      <t4-data-table matSortActive="CreatedAt" #sparePartsClaims [rawData]="filteredWaitingForSparePartsClaims" headline="" [allowFilter]="false" matSort [filterFields]="['Country','ClaimId', 'RequestNo', 'RentalObject.Title', 'RentalObject.RentalLocation.Name', 'RentalObject.RentalLocation.City', 'Owner']" [autoGenerateColumns]="false">

        <!-- ID Column -->
        <ng-container matColumnDef="userId">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 50px;"></mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 50px;" (click)="showDetails(row.Id)"><div class="statusIcon" [ngClass]="{'status-red': (row.CreatedAt < threeDaysBack), 'status-yellow': (row.CreatedAt < yesterday && row.CreatedAt >= threeDaysBack) }"></div></mat-cell>
        </ng-container>
        <ng-container matColumnDef="Country">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblCountry' | translate:'Country'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.Country }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="ClaimId">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Claims.lblClaimId' | translate:'Claim Id'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.ClaimId }}</mat-cell>
        </ng-container>

        <!-- Progress Column -->
        <ng-container matColumnDef="CreatedAt">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblCreated' | translate:'Created at'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.CreatedAt | date : 'yyMMdd' }}</mat-cell>
        </ng-container>

        <!-- Color Column -->
        <ng-container matColumnDef="RentalObject.Title">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblTrailer' | translate:'Trailer'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;"><t4-object-link [objectId]="row.RentalObject.Id">{{row.RentalObject.Title}}</t4-object-link></mat-cell>
        </ng-container>
        <ng-container matColumnDef="RentalObject.RentalLocation.Name">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 200px;">{{ 'Turbo.OneWayAdmin.Service.lblTrailer' | translate:'Trailer'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 200px;"><t4-location-link [locationId]="row.RentalObject.RentalLocation.Id">{{ row.RentalObject.RentalLocation.Name }}</t4-location-link></mat-cell>
        </ng-container>
        <ng-container matColumnDef="Status">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 150px;">
            {{
 'Turbo.OneWayAdmin.Service.lblStatus' | translate:'Status'
            }}
          </mat-header-cell>
          <mat-cell *matCellDef="let row" (click)="showDetails(row.Id)" style="flex: 0 0 150px;">{{ 'Turbo.OneWayAdmin.Service.ServiceStatus.' + row.Status | translate }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="StatusDate">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Claims.lblStatusDate' | translate:'Status date'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.StatusDate | date : 'yyMMdd' }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Owner">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblOwner' | translate:'Owner'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.Owner }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Description">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Turbo.OneWayAdmin.Service.lblDescription' | translate:'Description'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" (click)="showDetails(row.Id)">{{ row.Description }}</mat-cell>
        </ng-container>

      </t4-data-table>
    </mat-tab>

    <mat-tab label="{{ 'Turbo.OneWayAdmin.Claims.headWaitingForService' | translate:'Waiting for service'}} ({{ serviceClaims?.data?.filteredData?.length }})">

      <t4-data-table matSortActive="CreatedAt" #serviceClaims [rawData]="filteredWaitingForServiceClaims" headline="" [allowFilter]="false" matSort [filterFields]="['Country','ClaimId', 'RequestNo', 'RentalObject.Title', 'RentalObject.RentalLocation.Name', 'RentalObject.RentalLocation.City', 'Owner']" [autoGenerateColumns]="false">

        <!-- ID Column -->
        <ng-container matColumnDef="userId">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 50px;"></mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 50px;" (click)="showDetails(row.Id)"><div class="statusIcon" [ngClass]="{'status-red': (row.CreatedAt < threeDaysBack), 'status-yellow': (row.CreatedAt < yesterday && row.CreatedAt >= threeDaysBack) }"></div></mat-cell>
        </ng-container>
        <ng-container matColumnDef="Country">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblCountry' | translate:'Country'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.Country }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="ClaimId">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Claims.lblClaimId' | translate:'Claim Id'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.ClaimId }}</mat-cell>
        </ng-container>

        <!-- Progress Column -->
        <ng-container matColumnDef="CreatedAt">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblCreated' | translate:'Created at'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.CreatedAt | date : 'yyMMdd' }}</mat-cell>
        </ng-container>

        <!-- Color Column -->
        <ng-container matColumnDef="RentalObject.Title">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblTrailer' | translate:'Trailer'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;"><t4-object-link [objectId]="row.RentalObject.Id">{{row.RentalObject.Title}}</t4-object-link></mat-cell>
        </ng-container>
        <ng-container matColumnDef="RentalObject.RentalLocation.Name">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 200px;">{{ 'Turbo.OneWayAdmin.Service.lblTrailer' | translate:'Trailer'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 200px;"><t4-location-link [locationId]="row.RentalObject.RentalLocation.Id">{{ row.RentalObject.RentalLocation.Name }}</t4-location-link></mat-cell>
        </ng-container>
        <ng-container matColumnDef="Status">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 150px;">
            {{
 'Turbo.OneWayAdmin.Service.lblStatus' | translate:'Status'
            }}
          </mat-header-cell>
          <mat-cell *matCellDef="let row" (click)="showDetails(row.Id)" style="flex: 0 0 150px;">{{ 'Turbo.OneWayAdmin.Service.ServiceStatus.' + row.Status | translate }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="StatusDate">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Claims.lblStatusDate' | translate:'Status date'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.StatusDate | date : 'yyMMdd' }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Owner">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblOwner' | translate:'Owner'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.Owner }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Description">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Turbo.OneWayAdmin.Service.lblDescription' | translate:'Description'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" (click)="showDetails(row.Id)">{{ row.Description }}</mat-cell>
        </ng-container>

      </t4-data-table>
    </mat-tab>

    <mat-tab label="{{ 'Turbo.OneWayAdmin.Claims.headAllOpenClaims' | translate:'All open claims'}} ({{ openClaims?.data?.filteredData?.length }})">

      <t4-data-table matSortActive="CreatedAt" #openClaims [rawData]="filteredOpenClaims" headline="" [allowFilter]="false" matSort [filterFields]="['Country','ClaimId', 'RequestNo', 'RentalObject.Title', 'RentalObject.RentalLocation.Name', 'RentalObject.RentalLocation.City', 'Owner']" [autoGenerateColumns]="false">

        <!-- ID Column -->
        <ng-container matColumnDef="userId">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 50px;"></mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 50px;" (click)="showDetails(row.Id)"><div class="statusIcon" [ngClass]="{'status-red': (row.CreatedAt < threeDaysBack), 'status-yellow': (row.CreatedAt < yesterday && row.CreatedAt >= threeDaysBack) }"></div></mat-cell>
        </ng-container>
        <ng-container matColumnDef="Country">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblCountry' | translate:'Country'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.Country }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="ClaimId">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Claims.lblClaimId' | translate:'Claim Id'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.ClaimId }}</mat-cell>
        </ng-container>

        <!-- Progress Column -->
        <ng-container matColumnDef="CreatedAt">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblCreated' | translate:'Created at'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.CreatedAt | date : 'yyMMdd' }}</mat-cell>
        </ng-container>

        <!-- Color Column -->
        <ng-container matColumnDef="RentalObject.Title">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblTrailer' | translate:'Trailer'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;"><t4-object-link [objectId]="row.RentalObject.Id">{{row.RentalObject.Title}}</t4-object-link></mat-cell>
        </ng-container>
        <ng-container matColumnDef="RentalObject.RentalLocation.Name">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 200px;">{{ 'Turbo.OneWayAdmin.Service.lblTrailer' | translate:'Trailer'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 200px;"><t4-location-link [locationId]="row.RentalObject.RentalLocation.Id">{{ row.RentalObject.RentalLocation.Name }}</t4-location-link></mat-cell>
        </ng-container>
        <ng-container matColumnDef="Status">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 150px;">
            {{
 'Turbo.OneWayAdmin.Service.lblStatus' | translate:'Status'
            }}
          </mat-header-cell>
          <mat-cell *matCellDef="let row" (click)="showDetails(row.Id)" style="flex: 0 0 150px;">{{ 'Turbo.OneWayAdmin.Service.ServiceStatus.' + row.Status | translate }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="StatusDate">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Claims.lblStatusDate' | translate:'Status date'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.StatusDate | date : 'yyMMdd' }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Owner">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblOwner' | translate:'Owner'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.Owner }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Description">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Turbo.OneWayAdmin.Service.lblDescription' | translate:'Description'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" (click)="showDetails(row.Id)">{{ row.Description }}</mat-cell>
        </ng-container>

      </t4-data-table>
    </mat-tab>

    <mat-tab label="{{ 'Turbo.OneWayAdmin.Claims.headClosed' | translate:'Closed'}} ({{ closedClaims?.data?.filteredData?.length }})">

      <t4-data-table matSortActive="CreatedAt" #closedClaims [rawData]="filteredClosedClaims" headline="" [allowFilter]="false" matSort [filterFields]="['Country','ClaimId', 'RequestNo', 'RentalObject.Title', 'RentalObject.RentalLocation.Name', 'RentalObject.RentalLocation.City', 'Owner']" [autoGenerateColumns]="false">

        <!-- ID Column -->
        <ng-container matColumnDef="userId">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 50px;"></mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 50px;" (click)="showDetails(row.Id)"><div class="statusIcon" [ngClass]="{'status-red': (row.CreatedAt < threeDaysBack), 'status-yellow': (row.CreatedAt < yesterday && row.CreatedAt >= threeDaysBack) }"></div></mat-cell>
        </ng-container>
        <ng-container matColumnDef="Country">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblCountry' | translate:'Country'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.Country }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="ClaimId">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Claims.lblClaimId' | translate:'Claim Id'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.ClaimId }}</mat-cell>
        </ng-container>

        <!-- Progress Column -->
        <ng-container matColumnDef="CreatedAt">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblCreated' | translate:'Created at'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.CreatedAt | date : 'yyMMdd' }}</mat-cell>
        </ng-container>

        <!-- Color Column -->
        <ng-container matColumnDef="RentalObject.Title">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblTrailer' | translate:'Trailer'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;"><t4-object-link [objectId]="row.RentalObject.Id">{{row.RentalObject.Title}}</t4-object-link></mat-cell>
        </ng-container>
        <ng-container matColumnDef="RentalObject.RentalLocation.Name">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 200px;">{{ 'Turbo.OneWayAdmin.Service.lblTrailer' | translate:'Trailer'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 200px;"><t4-location-link [locationId]="row.RentalObject.RentalLocation.Id">{{ row.RentalObject.RentalLocation.Name }}</t4-location-link></mat-cell>
        </ng-container>
        <ng-container matColumnDef="Status">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 150px;">
            {{
 'Turbo.OneWayAdmin.Service.lblStatus' | translate:'Status'
            }}
          </mat-header-cell>
          <mat-cell *matCellDef="let row" (click)="showDetails(row.Id)" style="flex: 0 0 150px;">{{ 'Turbo.OneWayAdmin.Service.ServiceStatus.' + row.Status | translate }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="StatusDate">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Claims.lblStatusDate' | translate:'Status date'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.StatusDate | date : 'yyMMdd' }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Owner">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblOwner' | translate:'Owner'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.Owner }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Description">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Turbo.OneWayAdmin.Service.lblDescription' | translate:'Description'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" (click)="showDetails(row.Id)">{{ row.Description }}</mat-cell>
        </ng-container>

      </t4-data-table>
    </mat-tab>

  </mat-tab-group>
</t4-container>
